var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31497 11.055V15.231M10.561 8.638V6.555C10.561 5.663 9.83397 4.94 8.93797 4.94C8.04197 4.94 7.31497 5.663 7.31497 6.555V10.302M7.31497 10.302L5.85597 10.764C5.26555 10.9512 4.74583 11.3131 4.36551 11.802C3.98519 12.2909 3.76219 12.8837 3.72597 13.502L3.71097 13.758C3.65484 14.7209 3.79606 15.6851 4.12595 16.5915C4.45584 17.4979 4.96746 18.3273 5.6294 19.0288C6.29134 19.7304 7.08965 20.2893 7.97534 20.6712C8.86103 21.0532 9.81543 21.2501 10.78 21.25H13.73C15.4724 21.25 17.1436 20.5578 18.3757 19.3257C19.6078 18.0936 20.3 16.4225 20.3 14.68V8.745C20.2986 8.3157 20.127 7.90447 19.8227 7.60166C19.5183 7.29885 19.1063 7.12921 18.677 7.13C18.2475 7.12894 17.8352 7.29846 17.5306 7.60131C17.2261 7.90415 17.0543 8.31553 17.053 8.745M7.31497 10.302L7.31397 11.4M10.561 9.736V4.365C10.5623 3.9357 10.734 3.52447 11.0383 3.22166C11.3426 2.91885 11.7547 2.74921 12.184 2.75C13.081 2.75 13.807 3.473 13.807 4.365V9.73M13.807 9.735V6.555C13.8217 6.13442 13.9992 5.73599 14.302 5.44367C14.6047 5.15136 15.0091 4.98799 15.43 4.98799C15.8508 4.98799 16.2552 5.15136 16.558 5.44367C16.8607 5.73599 17.0382 6.13442 17.053 6.555V8.745M17.053 8.745V9.735",
    stroke: "#5070DE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/handIcon.30c4920653142124bd4796b2daa44d60.svg";
export { ForwardRef as ReactComponent };